import * as yup from 'yup'

export const stealSchema = yup.object().shape({
  team_id: yup.number().typeError('Invalid team'),
  bid: yup.number().integer('Only integers allowed').typeError('Invalid bid'),
})
